import React from 'react';
import {useFormikContext} from 'formik';
import {TextField, Card, Grid} from '@mui/material';

export default function DeaccessionEntryTwo() {
  const {values} = useFormikContext();

  const getDisplayValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  return (
    <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 10}}>
      {values?.dimensions && values?.dimensions?.length > 0 && (
        <Grid container spacing={1.5}>
          {values?.dimensions?.map((dimension, dimIndex) => {
            return dimension?.items?.map((item, itemIndex) => (
              <Grid item sm={6} xs={12} key={`${dimIndex}-${itemIndex}`}>
                <TextField 
                  variant={'outlined'} 
                  size={'small'} 
                  fullWidth 
                  label={item?.label}
                  value={`${item?.value || ''} ${item?.unit || ''}`}
                  disabled
                  InputLabelProps={{
                    style: {fontSize: 14, color: '#929191'},
                    shrink: true,
                    marginDense: false
                  }}
                />
              </Grid>
            ))
          })}
        </Grid>
      )}
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Dyes'}
        value={getDisplayValue(values?.dyes)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Motifs'}
        value={getDisplayValue(values?.motifs)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Description'}
        value={getDisplayValue(values?.description)}
        disabled 
        multiline 
        minRows={3} 
        maxRows={3}
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
    </Card>
  );
}